import { createApi } from '@reduxjs/toolkit/query/react';

import {
  OverseasMissionFormPostRequest,
  HrmRequestFormResponse,
} from '@Types/api/form';
import {
  RequestListSearchRequest,
  RequestListSearchResponse,
} from '@Types/api/requestList';
import { ApiBaseName, ApiReducerPath, RequestTypeCodes } from '@Enum/index';
import { PAGE_SIZE, TABLE_PAGE_DEFAULT } from '@Features/constants';
import { customBaseQuery } from '@Utils/api/customBaseQuery';

const REQ_TYPE_FILTER = {
  name: 'requestTypeID',
  value: RequestTypeCodes.OVERSEAS_MISSION,
  operator: 'eq',
};

export const overseasMissionApi = createApi({
  tagTypes: ['overseasMission'],
  reducerPath: ApiReducerPath.API_OVERSEAS_MISSION,
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getOverseasRequests: builder.mutation<
      RequestListSearchResponse<HrmRequestFormResponse>,
      RequestListSearchRequest
    >({
      query: ({
        searchValue,
        filters = [],
        page = TABLE_PAGE_DEFAULT,
        size = PAGE_SIZE,
        sortBy = 'requestId',
        sortOrder = 'desc',
      }) => ({
        url: `${ApiBaseName.ESS}/hrm-request/search`,
        method: 'post',
        body: {
          searchValue,
          searchCriteriaList: [
            {
              searchCriterias: [...filters, REQ_TYPE_FILTER],
              dataOperator: 'and',
            },
          ],
          dataOperator: 'and',
        },
        params: { page, size, 'sort-by': sortBy, 'sort-order': sortOrder },
      }),
    }),
    postOverseasForm: builder.mutation<
      HrmRequestFormResponse,
      OverseasMissionFormPostRequest
    >({
      query: (body) => ({
        url: `${ApiBaseName.ESS}/hrm-request`,
        method: 'post',
        body: {
          ...body,
          requestTypeID: RequestTypeCodes.OVERSEAS_MISSION,
        },
      }),
      invalidatesTags: ['overseasMission'],
    }),
    formValidation: builder.mutation<
      HrmRequestFormResponse,
      OverseasMissionFormPostRequest
    >({
      query: (body) => ({
        url: `${ApiBaseName.ESS}/hrm-request/validate`,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const {
  usePostOverseasFormMutation,
  useFormValidationMutation,
  useGetOverseasRequestsMutation,
} = overseasMissionApi;
